import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { environment } from '../../environments/environment';


@Injectable()
export class IsDairyGuard implements CanActivate {
    constructor(private router: Router, private authenticationService: AuthenticationService) {}

    canActivate() {
        // let currentUserType = this.authenticationService.getCurrentUser().thirdParty.type;
        // let isAllowed = environment.dairyRoles.indexOf(currentUserType.code) !== -1;

        // if (!isAllowed) {
           // this.router.navigate(['/home']);
        // }
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/app/security/is-dairy.guard.ts